<script lang="ts">
    import type { ProductTitle } from '@tile/components/product-title/ProductTitle.ts';

    interface Props {
        title: ProductTitle;
        brandOnTop?: boolean;
    }

    const { title, brandOnTop = false }: Props = $props();
</script>

<p class={['reptile-product-short-title', brandOnTop && 'reptile-product-short-title--brand-on-top']}>
    <span class="reptile-product-short-title__brand">
        {title.brand}
    </span>
    <span class="reptile-product-short-title__title">{title.display}</span>
</p>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/mixins';

    .reptile-product-short-title {
        margin: 0;

        display: flex;
        flex-direction: column;
        row-gap: tokens.$oc-semantic-spacing-absolute-25;

        &__brand {
            text-transform: uppercase;
            font-family: tokens.$oc-semantic-font-copy-font-family;
            font-size: tokens.$oc-base-font-size-75;
            font-weight: tokens.$oc-base-font-weight-regular;
            line-height: tokens.$oc-base-font-line-height-100;
        }

        &__title {
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline;
            font-family: 'OttoSansMedium', tokens.$oc-semantic-font-copy-font-family;
            font-weight: 500;
            font-size: tokens.$oc-base-font-size-87;
            line-height: tokens.$oc-base-font-line-height-125;
            @include mixins.line-clamp(2);
        }
    }
</style>
